import React from 'react';
import { motion } from 'framer-motion';
export function FormulaSection() {
  return <section className="w-full bg-white pt-6 md:pt-8 pb-0 px-6" data-id="element-239">
      <div className="max-w-5xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center justify-center w-full max-w-4xl mx-auto" data-id="element-241">
          <div className="w-full overflow-hidden rounded-2xl shadow-sm" data-id="element-242">
            <img src="https://cdn.magicpatterns.com/uploads/ooUV6oEeSgWRAgZ9xggfrR/Imagen_28-3-26_a_las_9.15_p._m..jpg" alt="La fórmula paso a paso para lograr ventas en Shopify y en automático" className="w-full h-auto block scale-[1.02]" data-id="element-243" />
          </div>
        </motion.div>
      </div>
    </section>;
}